enum FundMorningStarGeographyType {
  USA = 'USA',
  CANADA = 'Canada',
  LATIN_AMERIKA = 'Latin_Amerika',
  STORBRITANNIA = 'Storbritannia',
  EURO_SONEN = 'Euro_sonen',
  EUROPA_EX_EURO = 'Europa_ex_Euro',
  EUROPA_FREMVOKSENDE = 'Europa_Fremvoksende',
  AFRIKA = 'Afrika',
  MIDTOSTEN = 'Midtøsten',
  JAPAN = 'Japan',
  AUSTRALIA = 'Australia',
  ASIA_UTVIKLET = 'Asia_Utviklet',
  ASIA_FREMVOKSENDE = 'Asia_Fremvoksende',
  FREMVOKSENDE_MARKEDER = 'Fremvoksende_markeder',
  UTVIKLEDE_MARKEDER = 'Utviklede_Markeder',
  ANNET = 'Annet',
  UDEFINERT = 'Udefinert',
}

export default FundMorningStarGeographyType;
